import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import nlTranslation from './languages/dutchTranslations.json';
import enTranslation from './languages/englishTranslations.json';
import frTranslation from './languages/frenchTranslations.json';
import deTranslation from './languages/germanTranslations.json';
import esTranslation from './languages/spanishTranslations.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // bind react-i18next to the instance
  .init({
    fallbackLng: 'fr',
    debug: true,
    resources: {
      en: {
        translation: enTranslation,
      },
      fr: {
        translation: frTranslation,
      },
      nl: {
        translation: nlTranslation,
      },
      es: {
        translation: esTranslation,
      },
      de: {
        translation: deTranslation,
      },
    },
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'], // Cache the language selection
    },
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export const translate = (key: string, options = {}) => {
  return i18n.t(key, options);
};

export const changeLanguage = (language: string) => {
  return i18n.changeLanguage(language);
};

export default i18n;
